import Vue from "vue";
import VueRouter from "vue-router";
import LoginPage from "../views/LoginPage.vue";
import RegisterPage from "../views/RegisterPage.vue";
import UserPage from "../views/UserManagementPage.vue";
import UserInfoDetail from "../views/UserInfoDetailPage.vue";
import ProductPage from "../views/ProductManagementPage.vue";
import ProductInfoDetail from "../views/ProductDetailPage.vue";
import ForgetPassword from "@/views/ForgetPassword.vue";
import MemberPage from "@/views/MemberPage.vue";
import PersonalInfo from "@/views/PersonalInfo.vue";
import Notification from "@/views/NotificationPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: () => {
      // Check if token exists
      const token = JSON.parse(localStorage.getItem("crm-customer"))?.token;
      if (token) {
        // If token exists, redirect to '/user'
        return "/user-management";
      } else {
        // If token doesn't exist, redirect to '/login'
        return "/login";
      }
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
  },
  {
    path: "/register",
    name: "register",
    component: RegisterPage,
  },
  {
    path: "/forget-password",
    name: "forgot password",
    component: ForgetPassword,
  },
  {
    path: "/user-management",
    name: "user management",
    component: UserPage,
  },
  {
    path: "/user-info-detail/:id",
    name: "user detail",
    component: UserInfoDetail,
  },
  {
    path: "/building-management",
    name: "product management",
    component: ProductPage,
  },
  {
    path: "/buildling-detail/:id",
    name: "buildling management",
    component: ProductInfoDetail,
  },
  {
    path: "/members",
    name: "members",
    component: MemberPage,
  },
  {
    path: "/personal-info",
    name: "personal info",
    component: PersonalInfo,
  },
  {
    path: "/notifications",
    name: "notification",
    component: Notification,
  },
  {
    path: "/group-management",
    name: "group management",
    component: () => import("@/views/GroupManagementPage.vue"),
  },
  {
    path: "/group-detail/:id",
    name: "group detail",
    component: () => import("@/views/GroupDetailPage.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});
// Add a global navigation guard
router.beforeEach((to, from, next) => {
  // If the route requires authentication and there's no token
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !JSON.parse(localStorage.getItem("crm-customer"))?.token
  ) {
    // Redirect to login page
    next("/login");
  } else {
    next();
  }
});

export default router;
